import { render, staticRenderFns } from "./scientificeAndResearch.vue?vue&type=template&id=4debd450&scoped=true"
import script from "./scientificeAndResearch.vue?vue&type=script&lang=js"
export * from "./scientificeAndResearch.vue?vue&type=script&lang=js"
import style0 from "./scientificeAndResearch.vue?vue&type=style&index=0&id=4debd450&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4debd450",
  null
  
)

export default component.exports